
import enableBindingToOthers from './enableBindingToOthers';
//import enableHash from '../core/enableHash';
import capitalizeFirstLetter from '../core/capitalizeFirstLetter';
//import PropertyBindings from './PropertyBindings';
//import PropertyBinding from './PropertyBinding';
import PropertyHelper from './PropertyHelper';
//import PropertyBindingCarriedOver from './PropertyBindingCarriedOver';
//import PropertyBindingShell from './PropertyBindingShell';
import ParameterErrors from '../errors/ParameterErrors';
const {throwNotProvided }= ParameterErrors
export default class  PropertyBinding{
		constructor (me, model, name, valueChanged){
			this._me = me;
			this._model = model;
			this._name = name;
			this._valueChanged = valueChanged;
			this._disposed=false;
			
			this.set = this.set.bind(this);
			this.get = this.get.bind(this);
			this.getName = this.getName.bind(this);
			this.dispose= this.dispose.bind(this);
			this.unbind = this.unbind.bind(this);
			
			const capitalizedName = capitalizeFirstLetter(name);
			this._setterName = PropertyHelper.getSetterName(capitalizedName);
			this._getterName = PropertyHelper.getGetterName(capitalizedName);
			if(!model)throwNotProvided('model');
			model.bind(name, valueChanged);
			const myPropertyBindings= enableBindingToOthers(me);
			myPropertyBindings.add(this);
		}
		set(value){
			var setter = this._model[this._setterName];
			if(!setter)
				throw new Error('model of type '+this._model.constructor.name+' does not contain a setter method with name '+this._setterName);
			if(typeof(setter)!=='function')
				throw new Error(this._model.constructor.name+'.'+this._setterName+' is not a function');
			setter(value);
		}
		get(){
			var getter = this._model[this._getterName];
			if(!getter)throw new Error('model of type '+this._model.constructor.name+' does not contain a getter method with name '+this._getterName);
			if(typeof(getter)!=='function')
				throw new Error(this._model.constructor.name+'.'+this._getterName+' is not a function');
			return getter();
		}
		getName(){
			return this._name;
		}
		dispose(){
			if(this._disposed)return;
			this._disposed=true;
			this._me.myBindings.remove(this);
			this.unbind();
		}
		unbind(){
			this._model.unbind(this._name, this._valueChanged);
		}
	}